import axios from "axios";
let hasLoggedOut = false;
axios.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401 && !hasLoggedOut) {
			hasLoggedOut = true;
			alert("Your session has expired. Please log in again.");
			//console.log("Unauthorized access detected. Redirecting to login page...");

			sessionStorage.clear();
			window.location.replace("/");
		} else if (
			error.response?.status === 500 &&
			!hasLoggedOut &&
			process.env.NODE_ENV === "production"
		) {
			hasLoggedOut = true;
			//console.log("Unauthorized access detected. Redirecting to login page...");
			alert(
				"Server Error. Please try signing in again. If the problem persists, contact TSQS for assistance.",
			);

			sessionStorage.clear();
			window.location.replace("/");
		}
		return Promise.reject(error);
	},
);

const urlSPOT = process.env.REACT_APP_BACKEND_HOST.concat("/spot/");
const urlAuth = process.env.REACT_APP_BACKEND_HOST.concat("/auth/");
const urlScanner = process.env.REACT_APP_BACKEND_HOST.concat("/scanner/");
const urlUSRI = process.env.REACT_APP_BACKEND_HOST.concat("/usri/");

// export async function getAllClassIdsAsList(token) {
// 	return new Promise((resolve, reject) => {
// 		axios({
// 			method: "get",
// 			url: urlSPOT + "get_all_classids_as_list/",
// 			headers: {
// 				Authorization: `Token ${token}`,
// 			},
// 		})
// 			.then((response) => {
// 				if (response.status === 200) {
// 					resolve(response);
// 				}
// 			})
// 			.catch((error) => {
// 				reject(error);
// 				console.log("error");
// 				console.log(error);
// 			});
// 	});
// }

// axios({
// 			headers: {
// 				"Content-Type": "application/json",
// 				Accept: "application/json",
// 				Authorization: `Token ${token}`,
// 			},
// 			method: "get",
// 			url: process.env.REACT_APP_BACKEND_HOST.concat(
// 				"/scanner/department_classes/".concat(`${deptID}`).concat("/")
// 			),

export async function getClassesFromDepartmentsRFS(token, deptid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlScanner + "department_classes_list/".concat(`${deptid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
				console.log("error");
				console.log(error);
			});
	});
}

export async function getViewCatalog(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_viewcatalog/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getCompleteGradingRequest(token, reqnum) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlScanner + "get_complete_grading_request/".concat(reqnum).concat("/"),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
				console.log("error");
				console.log(error);
			});
	});
}

export async function getScanningCalendarData(token, startDate, endDate) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlScanner + `scanning_calendar_data/${startDate}/${endDate}/`,
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
				console.log("error fetching scanning calendar data");
				console.log(error);
			});
	});
}

export async function getInstructorsStudentRole(token, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "get_instructors_student_role/" + term + "/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
				console.log("error");
				console.log(error);
			});
	});
}

export async function getSpotReportDataMultiDownload(token, requisitions) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: urlSPOT + "fetch_spot_report_data/",
			headers: {
				Authorization: `Token ${token}`,
			},
			data: {
				requisitions: requisitions,
				action: "download",
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
				console.log("error");
				console.log(error);
			});
	});
}

export async function getSpotReportDataSingle(token, requisitions) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_spot_report_data/".concat(`${requisitions}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
				console.log("error");
				console.log(error);
			});
	});
}

export async function getWebUsers(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "get_web_users/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					// console.log("response", response.data);
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function fetchSTDUSRIResults(token, terms, empids, course) {
	const termsVal = "(" + terms + ")";

	const empidsVal = empids === "None" ? "None" : "(" + empids + ")";
	const courseVal = course === "None" ? "None" : course;
	const array = [termsVal, empidsVal, courseVal];
	const params = array.join(";");

	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT.concat("std_usri_results/").concat(params).concat("/"),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					const json = response.data;

					let apiData = [];
					for (let i = 0; i < json.length; i++) {
						let entry = {
							id: i + 1,
							reqnum: json[i].REQNUM,
							clsnum: json[i].CLSNUM,
							faculty: json[i].FNAME.trim(),
							department: json[i].DNAME.trim(),
							description: json[i].DESCRIPTION,
							acyear: json[i].ACYEAR.trim(),
							term: json[i].DESC_TERM.trim(),
							termNum: json[i].TERM,
							classid: json[i].CLASSID,
							course: json[i].CTITLE.trim(),
							ctype: json[i].CTYPE.trim(),
							empid: json[i].EMPID,
							name: json[i].NAME.trim(),
							report_id: json[i].REPORT_ID,
							ref1: json[i].REF1.trim(),
							ref2: json[i].REF2.trim(),
							ref3: json[i].REF3.trim(),
							ref_group: json[i].REF1.trim(),
							inst: json[i].NAME.trim().concat(" - ", json[i].EMPID),
						};
						apiData.push(entry);
					}
					function rankingSorter(firstKey, secondKey) {
						return function (a, b) {
							// Compare the values of the first key
							if (a[firstKey] > b[firstKey]) {
								return -1;
							} else if (a[firstKey] < b[firstKey]) {
								return 1;
							}
							// If the values of the first key are equal, compare the values of the second key
							else {
								if (a[secondKey] > b[secondKey]) {
									return 1;
								} else if (a[secondKey] < b[secondKey]) {
									return -1;
								} else {
									return 0;
								}
							}
						};
					}

					apiData.sort(rankingSorter("termNum", "ctitle"));

					resolve(apiData);
				}
			})
			.catch((error) => {
				console.log(error);

				reject(error);
			});
	});
}

export async function getUserAuthLevels(token, ccid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "userAuthLevel/".concat(`${ccid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
				console.log("error");
				console.log(error);
			});
	});
}

export async function getUSRIReportData(token, reqnums, reporttype, action = "view") {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: urlUSRI + "get_usri_report_data/".concat(`${reporttype}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
			data: {
				reqnums: reqnums,
				action: action,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					console.log("response data", response.data);
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
				console.log("error");
				console.log(error);
			});
	});
}

export async function getRFSListByCCID(token, ccid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlScanner + "requisitions_by_ccid/".concat(`${ccid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log("error");
				console.log(error);
			});
	});
}

export async function getLatestRFSByCCID(token, ccid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlScanner + "latest_requisition_by_ccid/".concat(`${ccid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log("error");
				console.log(error);
			});
	});
}

export async function getScannerRequestByReqnum(token, ccid, reqnum) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlScanner + "get_scanner_request_by_reqnum/".concat(`${ccid}/`).concat(`${reqnum}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
}

export async function sendMidtermEmails(token, batchSize, limit) {
	return new Promise((resolve, reject) => {
		axios({
			method: "GET",
			url: urlSPOT + "send_midterm_emails/".concat(`${batchSize}/`.concat(`${limit}/`)),
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function sendMidtermEmailsToSelected(token, term, ccids, emailConfig) {
	return new Promise((resolve, reject) => {
		axios({
			method: "POST",
			url: urlSPOT + "send_midterm_emails_selected/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: { term, ccids, emailConfig },
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function sendTestMidtermEmail(token, emailConfig) {
	return new Promise((resolve, reject) => {
		axios({
			method: "POST",
			url: urlSPOT + "send_one_midterm_test_email/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: { emailConfig },
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function populateMidtermEmails(token, term, isTest) {
	return new Promise((resolve, reject) => {
		axios({
			method: "GET",
			url: urlSPOT + `populate_midterm_emails/${term}/${isTest}/`,
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function checkMidtermEmails(token, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "GET",
			url: urlSPOT + `check_midterm_emails/${term}/`,
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function checkInstructorResultsEmail(token, deptId, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "GET",
			url: urlSPOT + "check_instructor_results_email/".concat(`${deptId}/`).concat(`${term}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				if (error.response.status === 404) {
					resolve({ error: "User not found" });
				}
				reject(error);
			});
	});
}

export async function checkAllDepartmentsForResultsEmail(token, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "GET",
			url: urlSPOT + "check_all_departments_for_results_email/".concat(`${term}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				if (error.response.status === 404) {
					resolve({ error: "Not Found" });
				}
				reject(error);
			});
	});
}

export async function sendInstructorResultsEmail(token, deptId, term, termString) {
	return new Promise((resolve, reject) => {
		axios({
			method: "POST",
			url: urlSPOT + "send_instructor_results_email/" + deptId + "/" + term + "/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: {
				termString: termString,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					// console.log("response", response);
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}
export async function getLDAPUserByEmpId(token, empid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlAuth + "employee_number_lookup".concat(`/${empid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);

				reject(error);
			});
	});
}

export async function getLDAPUserBySearchField(token, value, searchField) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "get_user_from_LDAP".concat(`/${value}`).concat(`/${searchField}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				// console.log("response", response);

				resolve(response.data);
			})
			.catch((error) => {
				console.log(error);

				reject(error);
			});
	});
}

export async function getBlockIds(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_blockids/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getBlockIdsByDept(token, deptid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_blockids_by_dept".concat(`/${deptid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getBlockItemsByBlockId(token, blockId) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_blockitems_by_blockid".concat(`/${blockId}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getCombinedClassIds(token, deptid, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_combined_class_ids".concat(`/${deptid}`).concat(`/${term}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getItemCategories(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_itemcategories/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getItemsData(token, itemnos) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_items_by_itemnos/?itemnos=".concat(`${itemnos}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getAllItems(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_items/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getAllBlockItems(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_all_blockitems/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getClassIdsByDeptIdAndTerm(token, deptid, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_classids_by_dept_and_term/".concat(`${deptid}`).concat(`/${term}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	});
}

export async function getBlueCoursesByDeptIdAndTerm(token, deptid, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_blue_courses_by_dept_and_term/".concat(`${deptid}`).concat(`/${term}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	});
}

export async function getClassIdsByFetchRolesByEmpId(token, empid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_classids_by_fetch_roles_by_empid".concat(`/${empid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	});
}

export async function getInstancedClassesByClassId(token, classid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_instanced_classes_by_classid".concat(`/${classid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log("error");
				console.log(error);
			});
	});
}

export async function getClassesByTerm(token, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_classes_by_term/".concat(`${term}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getClassesByDeptIdAndTerm(token, deptid, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_classes_by_dept_and_term/".concat(`${deptid}`).concat(`/${term}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getDepartments(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_departments/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getFacultyRank(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_faculty_rank/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	});
}

export async function getFacultyRankByCCID(token, ccid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_faculty_rank_by_ccid".concat(`/${ccid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	});
}

export async function getMidtermEvals(token, term) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_midterm_evals".concat(`/${term}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getTerms(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "terms_list/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getRolesByClassIds(token, classids) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_roles_by_multiclass/?classids=".concat(`${classids}`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getRolesByClassId(token, classid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_roles_by_classid".concat(`/${classid}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getReqnum(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_reqnum/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getHighestItemNo(token, itmtyp) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_highest_itemno".concat(`/${itmtyp}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getHighestItemNo20000(token, itmtyp) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_highest_itemno_20000".concat(`/${itmtyp}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getRequisitionsAllData(token, ccid, termNumber) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_requisitions_all_data/".concat(`${ccid}/`).concat(`${termNumber}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function getSTDUsriSearchParams(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "std_info_usri/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function fetchResultsEmailNotifications(token) {
	return new Promise((resolve, reject) => {
		axios({
			method: "get",
			url: urlSPOT + "fetch_results_emails_notifications/",
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}
